import axios from 'axios';

export interface AdsTargeting {
  targeting: Record<string, string>;
}

const TIMEOUT_MS = 1000;

export async function getGPTAdsTargeting(
  pageName: 'FLIGHT_SEARCH_RESULT',
  searchId: string,
  wegoAnalyticsClientId: string,
): Promise<AdsTargeting> {
  const queryParams = new URLSearchParams({
    page_name: pageName,
    search_id: searchId,
  });

  const url = `${API_BASE_URL}/partner-success/v1/targeting/gam?${queryParams}`;

  const response = await axios.get<AdsTargeting>(url, {
    headers: { 'X-WEGO-CLIENT-ID': wegoAnalyticsClientId },
    withCredentials: true,
    timeout: TIMEOUT_MS,
  });

  if (response.status === 200) {
    return response.data;
  }
  throw new Error(response.statusText);
}
